/* eslint-disable no-unused-vars */
import zaraz from 'utils/trackers/zaraz';

export default class ZarazIntegration {
  static integrationName = 'zaraz';
  static enabled = true;
  static ready = false;
  static retry = 0;

  static setup() {
    if (this.ready) {
      return true;
    }

    this.identify();
    this.ready = true;
    return true;
  }

  static identify() {
    const userData = this.getUserData();
    const {
      id,
      subscriptionStatus,
      email,
      segment,
      created_at,
      previousExperience
    } = this.getUserData();

    if (!id) {
      return;
    }

    zaraz.set('userId', id);
    zaraz.set('user_subscription', subscriptionStatus);
    zaraz.set('email', email);
    zaraz.set('segment', segment);
    zaraz.set('created_at', created_at);
    zaraz.set('previous_experience', previousExperience);

    if (previousExperience) {
      zaraz.set('previous_experience', previousExperience);
    }
  }

  static getUserData() {
    const user = $('#js-current-user').get(0);

    if (!user) {
      return { id: null, subscriptionStatus: undefined };
    }

    return user.dataset;
  }

  static pageVisited({ pageName = 'default_2', data = {} }) {
    // zaraz not implemented this method
    return;
  }

  static builderPageVisited({ pageName = 'default_4', campaignType = 'Generic', data = {} }) {
    // zaraz not implemented this method
    return;
  }

  static emit(fn, params) {
    this[fn](params);
  }

  static event({ eventName = 'default_1', data = {} }) {
    // zaraz not implemented this method
    return;
  }

  static send(key, params) {
    this.identify();
  }
}
